import axios from 'axios';

import { sleep } from 'utils';
import { getMSEndpointFromLS } from 'reducers/installer';

export const defaultChaseUrl = 'https://localhost.erply.com:10100/api/v1/';

export const getChaseUrl = () => {
  const endpoint = getMSEndpointFromLS('chase');
  return endpoint ? `${endpoint}api/v1/` : defaultChaseUrl;
};

const chaseDetails = () => ({
  baseURL: getChaseUrl(),
  timeout: 180000,
  headers: {
    Accept: '*',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

const chaseRequest = () => axios.create(chaseDetails());

export const testConnEndpoint = `${chaseDetails.baseURL}testConnection`;

export const testConnection = () => {
  return chaseRequest()
    .get('testConnection')
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to test connection for Chase', e);
      return e;
    });
};

export const requestSale = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'Sale', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to process payment with Chase', params);
      return e;
    })
    .finally(
      // Without this throttling the requests are sent faster than the terminal can recieve them.
      result => sleep(0.2).then(() => result),
    );
};

export const requestReturn = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'Refund', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to process refund with Chase', e);
      return e;
    })
    .finally(
      // Without this throttling the requests are sent faster than the terminal can recieve them.
      result => sleep(2).then(() => result),
    );
};

export const requestVoid = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'Void', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to process void with Chase', e);
      return e;
    })
    .finally(
      // Without this throttling the requests are sent faster than the terminal can recieve them.
      result => sleep(2).then(() => result),
    );
};

export const requestCloseBatch = () => {
  return chaseRequest()
    .get('closeBatch')
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to close batch for Chase', e);
      return e;
    });
};

export const requestGiftCardIssuance = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'issuance', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to issue gift card with Chase', e);
      return e;
    });
};

export const requestGiftCardBalance = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'CardBalance', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to fetch gift card balance from Chase', e);
      return e;
    });
};

export const requestGiftCardActivation = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'Activation', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to activate gift card in Chase', e);
      return e;
    });
};

export const requestGiftCardActivationForced = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'ForceActivation', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to force-activate gift card in Chase', e);
      return e;
    });
};

export const requestGiftCardDeactivation = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'Deactivation', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to deactivate gift card in Chase', e);
      return e;
    });
};

export const requestGiftCardReactivation = params => {
  return chaseRequest()
    .post('payment', { transactionType: 'Reactivation', ...params })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to reactivate gift card in chase', e);
      return e;
    });
};

export const requestGetConfig = () => {
  return chaseRequest()
    .get('config')
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to load config from Chase', e);
      return e;
    });
};

export const requestSetConfig = params => {
  return chaseRequest()
    .post('config', { configJSON: JSON.stringify(params) })
    .then(response => {
      return response;
    })
    .catch(e => {
      console.error('Failed to write config to Chase', e);
      return e;
    });
};
